import { createSlice } from "@reduxjs/toolkit";

const popupSlice = createSlice({
  name: "popup",
  initialState: { message: "", visible: false, type: "error" },
  reducers: {
    setPopup: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type || "error"; // default red
      state.visible = true;
    },
    clearPopup: (state) => {
      state.message = "";
      state.visible = false;
      state.type = "error";
    },
  },
});

export const { setPopup, clearPopup } = popupSlice.actions;
export default popupSlice.reducer;
